type BuildType = 'stage' | 'production';

interface AppEnvironment {
    API_URL: string;
    API_SOCKET_URL: string;
    LANDING_URL: string;
    S3_URL: string;
    BUILD_TYPE: BuildType;
    REQUEST_CAPTCHA: boolean;
}

const get = <ReturnType extends string>(key: string): ReturnType => {
    const env = import.meta.env['VITE_' + key];
    if (env) return env;
    throw new Error(`Env var VITE_${key} was not provided`);
};

export const appEnvironment: AppEnvironment = {
    API_URL: get('SERVER_URL'),
    API_SOCKET_URL: get('SOCKET_URL'),
    LANDING_URL: get('LANDING_URL'),
    S3_URL: get('S3_URL'),
    BUILD_TYPE: get('BUILD_TYPE'),
    REQUEST_CAPTCHA: get('REQUEST_CAPTCHA') === 'true',
};
